module.exports = __webpack_public_path__ + "static/img/a029.46cfdde.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/banner/s/a029.jpg
// module id = ppdt
// module chunks = 0